'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fLink$002ejs from "@ui5/webcomponents/dist/Link.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-link");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$.prototype = $p;
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fLink$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$, "io.github.nguyenyou.ui5.webcomponents.laminar.Link$", ({
  jE: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_Link$ };
